import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthenticationService } from '../services/authentication.service'
import { PERMISSIONS } from '../models/constants';

export const adminGuard: CanActivateFn = async (route, state) => {
    const authService = inject(AuthenticationService);
    const router = inject(Router);

    let isAdmin = await authService.userHasPermission(PERMISSIONS.ADMIN);
    if(!authService.isAuthenticated() ) {
        router.navigate(['/login']);
        return false;
    }
    else if(!isAdmin) {
        router.navigate(['/permissiondenied']);
        return false;
    }
    else {
        return true;
    }
}